import React from "react";

import Trade from "./Trade";
import { getLocalUserInfoLocalStorage, statuses } from "../utils/utils";

function Column(props) {
    const { trades, customerDetailsTradeInfo, status, columnIndex, landScape } = props;
    const {
        showStoreName,
        showCustomerId, showCustomerFirstName, showCustomerLastName,
        showWaitTime
    } = getLocalUserInfoLocalStorage();
    const onlyOrderNumber = !(showStoreName || showCustomerId || showWaitTime || showCustomerFirstName || showCustomerLastName);

    if (trades.length !== 0) {
        if (customerDetailsTradeInfo) {
            trades.sort((t1, t2) => {
                const t1WaitTime = parseInt(customerDetailsTradeInfo[t1.id]?.waitTime) || 0;
                const t2WaitTime = parseInt(customerDetailsTradeInfo[t2.id]?.waitTime) || 0;
                return t1WaitTime - t2WaitTime;
            })
        }
        return (
            <div className={"trade-container" + (onlyOrderNumber ? " only-order-number" : "")}
                 style={{ gridTemplateColumns: landScape ? 'grid-template-columns: repeat(6, minmax(200px, max-content))' : 'grid-template-columns: repeat(auto-fit, minmax(200px, max-content))' }}>
                <Trade key={status}
                       trades={trades.filter(trade => {
                           return status === statuses[0] ?
                               trade.state in [1, 2, 3, 4] :
                               trade.state === 6;
                       })}
                       columnIndex={columnIndex}
                       customerDetailsTradeInfo={customerDetailsTradeInfo}
                       status={props.status} />
            </div>
        );
    } else {
        return (
            <div>

            </div>
        )
    }
}

export default (Column);
